// PDP accordion js start
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
// PDP accordion js end
 // Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("shipping-popup");

    if(modal)
    {
    	modal.onclick = function(ev) {
      		if(ev.target != this) return;
  			modal.style.display = "none";
		}
    }
    
// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal
    if(btn){
btn.onclick = function() {
  modal.style.display = "block";
}
    }
// When the user clicks on <span> (x), close the modal
    if(span){
		span.onclick = function() {
  			modal.style.display = "none";
		}
    }
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
// PDP mobile view modals code start
    // Get the modal
var modal1 = document.getElementById("myModal1");
   if(modal1)
   {
    modal1.onclick = function(ev) {
      	if(ev.target != this) return;
  		modal1.style.display = "none";
      document.body.classList.remove('payment-popup');
	}
   }
// Get the button that opens the modal
var btn1 = document.getElementById("mypaymentBtn");
// Get the <span> element that closes the modal
var span1 = document.getElementsByClassName("close1")[0];
// When the user clicks on the button, open the modal
     if(btn1){
		btn1.onclick = function() {
  			modal1.style.display = "block";
        document.body.classList.add('payment-popup');
		}
     }
// When the user clicks on <span> (x), close the modal
     if(span1){
     span1.onclick = function() {
  		modal1.style.display = "none";
      document.body.classList.remove('payment-popup');
	}
     }
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal1) {
    modal1.style.display = "none";
  }
}

    // Get the modal
var modal2 = document.getElementById("myModal2");
 if(modal2)
    {
    	modal2.onclick = function(ev) {
      		if(ev.target != this) return;
  			modal2.style.display = "none";
		}
    }
// Get the button that opens the modal
var btn2 = document.getElementById("mystylesBtn");
// Get the <span> element that closes the modal
var span2 = document.getElementsByClassName("close2")[0];
// When the user clicks on the button, open the modal
    if(btn2){
          btn2.onclick = function() {
        	modal2.style.display = "block";
            $('.mobilemenu-slider').slick('unslick');
            theme.mobileMenuSlider();
      	}
    }
// When the user clicks on <span> (x), close the modal
if(span2)
{
	span2.onclick = function() {
  		modal2.style.display = "none";
	}
}
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal2) {
    modal2.style.display = "none";
  }
} 
      // Get the modal
var myModarank = document.getElementById("myModarank");
// Get the button that opens the modal
var tagquestionimage = document.getElementById("tagquestionimage");
// Get the <span> element that closes the modal
var rankclose = document.getElementsByClassName("rankclose")[0];
// When the user clicks on the button, open the modal
    if(tagquestionimage)
    {
      tagquestionimage.onclick = function() {
        myModarank.style.display = "block";
      }
      // When the user clicks on <span> (x), close the modal
      rankclose.onclick = function() {
        myModarank.style.display = "none";
		}
    }
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == myModarank) {
    myModarank.style.display = "none";
  }
}

// PDP mobile view modals code end


/*========================= notificationModal =========================*/

var sidemodal = document.getElementById("notificationPopup");
if(sidemodal)
{
  sidemodal.onclick = function(ev) {
    if(ev.target != this) return;
    sidemodal.style.display = "none";
  }
}
// Get the button that opens the modal
var btn3 = document.getElementById("notificationModal");
// Get the <span> element that closes the modal
var span3 = document.getElementsByClassName("close3")[0];
// When the user clicks on the button, open the modal
if(btn3){
  btn3.onclick = function() {
    sidemodal.style.display = "block";
  }
}
// When the user clicks on <span> (x), close the modal
if(span3){
  span3.onclick = function() {
    sidemodal.style.display = "none";
  }
}
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == sidemodal) {
    sidemodal.style.display = "none";
  }
}


//HEM 08/06/22
// $('#notificationModal').click(function () {
//   $(".md_popup_wraper").addClass("popup_notic");
// });

// $('.close3').click(function () {
//   $(".md_popup_wraper").removeClass("popup_notic");
// });



/*========================= recommendedModal =========================*/

var prodModal = document.getElementById("recommendedPopup");
if(prodModal)
{
  prodModal.onclick = function(ev) {
    if(ev.target != this) return;
    prodModal.style.display = "none";
  }
}
// Get the button that opens the modal
var btn4 = document.getElementById("recommendedModal");
// Get the <span> element that closes the modal
var span4 = document.getElementsByClassName("close4")[0];
// When the user clicks on the button, open the modal
if(btn4){
  btn4.onclick = function() {
    prodModal.style.display = "block";
  }
}
// When the user clicks on <span> (x), close the modal
if(span4){
  span4.onclick = function() {
    prodModal.style.display = "none";
  }
}
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == prodModal) {
    prodModal.style.display = "none";
  }
}


/******/

// $('#recommendedModal').click(function(){
//   var categorypopup = $('#categorypage-nosto-1').children();
//   var categorypopupLength = categorypopup.length;
//   console.log(categorypopupLength);
  
//   var productPopup = $('#productpage-nosto-2').children();
//   var productPopupLength = productPopup.length;
//   console.log(productPopupLength);
// });


/*=============== Notification Badge ===============*/

var cardBlockSizeCurr = $('#block-card-size').val();
var cardBlockSizeGet = localStorage.getItem('card-block-size');

if(cardBlockSizeGet == ''){
  $('.bell-icon').addClass('hide');
}else{
  if(cardBlockSizeCurr > cardBlockSizeGet){
    $('#notificationModal').click(function(){
      localStorage.setItem("card-block-size", cardBlockSizeCurr);
      $('.bell-icon').addClass('hide');
    });
  }else{
    $('.bell-icon').addClass('hide');
    var cardBlockSizeGetNew = localStorage.getItem('card-block-size');
    if(cardBlockSizeCurr < cardBlockSizeGetNew){
      $('.bell-icon').removeClass('hide');
      $('#notificationModal').click(function(){
        $('.bell-icon').addClass('hide');
      });
      localStorage.setItem("card-block-size", "");
    }
  }
}


/*=============== Review button ===============*/
$(document).ready(function(){
  $(document).on('click', '.product-additional-heading', function(){
//     var review_count = $('.template-product .stamped-product-reviews-badge .stamped-badge .stamped-badge-caption').attr('data-reviews');
    var enableBtnClassLength = $(".enable_review_btn").length;
    if(enableBtnClassLength > 0){
      var review_count = $('.enable_review_btn .stamped-badge .stamped-badge-caption').attr('data-reviews');
      if (review_count > 0){
        $('.stamped-summary-actions').remove();
      }
    }
  });
});
theme.featured_image_add_to_cart = function($this){
  if($('.product_form_wrap:visible').length == 0){
    $('.bottom-sticky-product').addClass('add_to_cart_btn_popup');
    $('.product_form_wrap').show();
  }else{
    var allOptionSelected = true;
    for(var i=1;i<=$("[id^='swatch-option']").length;i++){
      var $this_option = $('.swatches-type-products #swatch-option'+i);
      if($this_option.find('.swatch-view li').length > 0){
        if($this_option.find('.swatch-view li[aria-checked="true"]').length == 0){
          if($this_option.find('.validate-mesaage').length == 0){
            $this_option.find('.swatch-view').after('<span class="validate-mesaage" style="color:red;  font-weight: bold;">Please Select option</span>');
          }
          allOptionSelected = false;
          break;
        }
      }
    }
    if(allOptionSelected){
      $('body').addClass('btn_second_show_loader');
      $this.addClass('btn--loading');
      $this.addClass('unload');
      setTimeout(function(){$this.removeClass('btn--loading'); }, 1000);
      setTimeout(function(){$this.removeClass('unload'); }, 1500);
      $('.product_form_wrap').hide();
      $('.product-single__form .add-to-cart.mobile_hide').trigger('click');
    }
  }
}
/*====================== Subscription ======================*/
$(document).ready(function(){
  var loginPageFormSubmit = setInterval(function() {
      var text_price = $('.variant__price_subscription').text();
      if(text_price != ''){
        $('.add-to-cart-wishlist-wrapper .add-to-cart').removeClass('disable');
        clearInterval(loginPageFormSubmit);
      }
  },100);

  // function defaultSelect(){var t=$(".subscription-plan-1").attr("data-plan-variant-option"),a=$(".subscription-plan-1").attr("var-price");$(".variant__price_subscription").text(a),$(".rc_widget__option__plans__dropdown option").each((function(){if($(this).attr("data-plan-option")==t){var a=$(this).val();$(".rc_widget__option__plans__dropdown").val(a).trigger("change")}}))}setTimeout(defaultSelect,5e3);

  
  $('.subscription-membership-plan-card').on('change',function(){
    $('.subscription-membership-plan-card').removeAttr('checked');
    var varPrice = $(this).attr('var-price');
    $('.variant__price_subscription').text(varPrice);
    var checked = $(this).attr('checked','checked');
    var variantPlan = $(this).attr('data-plan-variant-option');
    var varId = $(this).attr('var-id');
    $(".product-single__variants").val(varId).trigger("change");
    // console.log('Is id store',($(this).val()));
    $(".rc_widget__option__plans__dropdown option").each(function(){
      var option_attr_val = $(this).attr('data-plan-option');
      if(option_attr_val == variantPlan){
        var option_value = $(this).val();
        $(".rc_widget__option__plans__dropdown").val(option_value).trigger("change");
      }
    });
  });
  //bottom membership subscription btn click
  $('.bottom-subscription-btn').click(function(e){
    e.preventDefault();
    $('.top-subscription-btn').trigger('click');
  });

  /*====================== Navigation main menu ======================*/
  // make sure ".site-nav.site-navigation.medium-down--hide" default css display none
  var navMenu = setInterval(function(){
    if($('.tmenu_app_desktop').length > 0){
      $('.site-nav.site-navigation.medium-down--hide').show();
      clearInterval(navMenu);
    }
  }, 100);

  /*====================== Filter mobile menu ======================*/
  // make sure ".boost-pfs-filter-tree-mobile-button" default css display none
  var mobileFilterSearch = window.setInterval(function(){
    var btnFilterLengthSearchPage = $('.template-search .boost-pfs-filter-tree-mobile-button-label').length;
    
    if(btnFilterLengthSearchPage >= '1'){
      $('.template-search .boost-pfs-filter-tree-mobile-button').show();
      clearInterval(mobileFilterSearch);
    }
  }, 100);


  /*====================== native search bar close  ======================*/
  var nativSearchBar = setInterval(function(){
    if($('.boost-pfs-search-btn-close-suggestion').length > 0){
      $('.boost-pfs-search-btn-close-suggestion').click(function(){
       $('.js-search-header-close') .trigger('click');
      });
      clearInterval(nativSearchBar);
    }
  }, 100);


  var resultSearch = setInterval(function(){
    setTimeout(function() {
      if($('.boost-pfs-search-result-number').length > 0){
        var resultSearchText = $('.boost-pfs-search-result-number').text();
        if(resultSearchText == ''){
         $('.boost-pfs-search-result-number').html('<strong>Search</strong>');
        }
        clearInterval(nativSearchBar);
      }
    }, 2000);
  }, 100);


  /*====================== Home page section ======================*/
  /*===============================================================*/
  
  /*====================== Home banner  ======================*/
  $('.image-banner-slider-main').slick({
    infinite: true,
    slidesToShow: 1,
    arrows: false
  });

  /*====================== Image gallary  ======================*/
  $('.image_gallary_slider_main').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true
  });

  /*====================== BF shop by brand  ======================*/
  $('.bf_collection_slider').slick();
  /*====================== BF Recomended section ======================*/
  $('.bf_recomnded_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    adaptiveHeight: true
  });

  /*====================== collection-products.liquid ======================*/
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight() / 2;
    var viewportTop = $(window).scrollTop();
    var viewportHalf = viewportTop + $(window).height() / 2;
    return elementBottom > viewportTop && elementTop < viewportHalf;
  };
  let tab_triggered = false;
  let triggered = false;
  let triggered_desk = false;
  var data_page_size = $('.collection-products-load-more-link').attr("data-page-size");
  var product_count_custom;
  /* function ScrollExecute() {
    if($('.collection_product_page').is(':visible')){
      let nextUrl = $('.collection-products-load-more-link').attr("href");
      if ($(document).height() - 800 < ($(document).scrollTop() + $(window).height()) && (triggered == false)) {
          console.log("Next URL :", nextUrl);
        $('.kclot_logo_icon').removeClass('hide');
        triggered = true;
        $.ajax({
          url: nextUrl,
          type: 'GET',
          success: function (response) {
            // console.log(response);
            nextUrl = $(response).find(".collection-products-load-more-link").attr("href");
           product_count_custom = $(response).find(".product_count_custom").text();
            currentUrl = $('.collection-products-load-more-link').attr("href");
            $('.kclot_logo_icon').addClass('hide');
            $(".collection-get-product #product-grid").append(
              $(response).find("#product-grid").html()
            );
            if ($(response).find(".collection-products-load-more-main a").length > 0) {
              $(".collection-products-load-more-main a").attr(
                "href",
                $(response).find(".collection-products-load-more-main a").attr("href")
              );
              $(".collection-products-load-more-main").show();
            } else {
              $(".collection_product_page").hide();
              $('.kclot_logo_icon').remove();
              
            }
            console.log(nextUrl,currentUrl);
            triggered = false;
            if($('body.product-grid-with-cart').length > 0 || $('body.template-index').length > 0 ){
              console.log("functions calleddd");
              theme.grid_cart_btn();
              theme.grid_add_to_cart_click();
              theme.grid_popup_close();
              theme.grid_popup_on_change();
              if($(window).innerWidth() < 767 ){
                theme.body_click_close();
              }
            }
          }
        });
      }
    }
  } */
if($('.tab-collection-main-container').length > 0){
theme.tab_product_load_more(tab_triggered);
}
 function ScrollExecute() {
    if (window.matchMedia("(max-width: 750px)").matches) {
      var first_div = $('.collection-mobile:not(".doneload")').first() ;
      if(first_div.length > 0){
        if(first_div.isInViewport() && triggered == false){
          // console.log("Visiblee");
          var nextUrl = $('.auto-load-collection-mobile:not(".donecoll")').first().find('.collection-products-load-more-link').attr("href");             
            $('.auto-load-collection-mobile:not(".donecoll")').first().find('.kclot_logo_icon').removeClass('hide');
            var closest_id = $('.auto-load-collection-mobile:not(".donecoll")').first().closest('.custom_collection_product_grid').attr('id');
            triggered = true;
            $.ajax({
              url: nextUrl,
              type: 'GET',
              success: function (response) {
                // var response_first_data = $(response).find(".auto-load-collection-mobile:not('.donecoll')").first();
                nextUrl = $(response).find(`#${closest_id} .auto-load-collection-mobile:not('.donecoll') .collection-products-load-more-link`).attr("href");
              product_count_custom = $(response).find(`#${closest_id} .auto-load-collection-mobile:not('.donecoll') .product_count_custom`).first().text();
                currentUrl = $(`#${closest_id} .auto-load-collection-mobile:not(".donecoll") .collection-products-load-more-link`).attr("href");
                $(`#${closest_id} .auto-load-collection-mobile:not(".donecoll") .kclot_logo_icon`).addClass('hide');
                $(`#${closest_id} .auto-load-collection-mobile:not('.donecoll') .collection-get-product #product-grid`).append(
                  $(response).find(`#${closest_id} .auto-load-collection-mobile:not('.donecoll') #product-grid`).html()
                );
                
                if ($(response).find(`#${closest_id} .auto-load-collection-mobile:not('.donecoll') .collection-products-load-more-main a`).length > 0) {
                  $(`#${closest_id} .auto-load-collection-mobile:not('.donecoll') .collection-products-load-more-main a`).attr(
                    "href",
                    $(response).find(`#${closest_id} .auto-load-collection-mobile:not('.donecoll') .collection-products-load-more-main a`).attr("href")
                  );
                  $(`#${closest_id} .auto-load-collection-mobile:not('.donecoll') .collection-products-load-more-main`).show();
                } else {
                  $(`#${closest_id} .auto-load-collection-mobile:not('.donecoll') .collection_product_page`).hide();
                  $(`#${closest_id} .auto-load-collection-mobile:not(".donecoll") .kclot_logo_icon`).remove();
                  
                }
                if(nextUrl == undefined){
                  $('.collection_product_page.collection-mobile:not(".doneload")').first().addClass('doneload');
                  $('.auto-load-collection-mobile:not(".donecoll")').first().addClass('donecoll')
                  nextUrl = '';
                }
                console.log(nextUrl,currentUrl);
                triggered = false;
                if($('body.product-grid-with-cart').length > 0 || $('body.template-index').length > 0 ){
                  console.log("functions calleddd");
                  theme.grid_cart_btn();
                  theme.grid_add_to_cart_click();
                  theme.grid_popup_close();
                  theme.grid_popup_on_change();
                  if($(window).innerWidth() < 767 ){
                    theme.body_click_close();
                  }
                }
              }
            });
        }
      }
    }
    if (window.matchMedia("(min-width: 751px)").matches){
      var first_div_desk = $('.collection-desktop:not(".doneload")').first();
      if(first_div_desk.length > 0){
        if(first_div_desk.isInViewport() && (triggered_desk == false)){
            var nextUrl = $('.auto-load-collection-desktop:not(".donecoll")').first().find('.collection-products-load-more-link').attr("href");
                console.log("Next URL :", nextUrl);
              $('.auto-load-collection-desktop:not(".donecoll")').first().find('.kclot_logo_icon').removeClass('hide');
              var closest_id = $('.auto-load-collection-desktop:not(".donecoll")').first().closest('.custom_collection_product_grid').attr('id');
              triggered_desk = true;
              $.ajax({
                url: nextUrl,
                type: 'GET',
                success: function (response) {
                  
                  nextUrl = $(response).find(`#${closest_id} .auto-load-collection-desktop:not('.donecoll') .collection-products-load-more-link`).attr("href");
                product_count_custom = $(response).find(`#${closest_id} .auto-load-collection-desktop .product_count_custom`).text();
                  currentUrl = $(`#${closest_id} .auto-load-collection-desktop .collection-products-load-more-link`).attr("href");
                  $(`#${closest_id} .auto-load-collection-desktop:not('.donecoll') .kclot_logo_icon`).addClass('hide');
                  $(`#${closest_id} .auto-load-collection-desktop:not('.donecoll') .collection-get-product #product-grid`).append(
                    $(response).find(`#${closest_id} .auto-load-collection-desktop #product-grid`).html()
                  );
                  if ($(response).find(`#${closest_id} .auto-load-collection-desktop .collection-products-load-more-main a`).length > 0) {
                    $(`#${closest_id} .auto-load-collection-desktop:not('.donecoll') .collection-products-load-more-main a`).attr(
                      "href",
                      $(response).find(`#${closest_id} .auto-load-collection-desktop .collection-products-load-more-main a`).attr("href")
                    );
                    $(`#${closest_id} .auto-load-collection-desktop:not('.donecoll') .collection-products-load-more-main`).show();
                  } else {
                    $(`#${closest_id} .auto-load-collection-desktop:not('.donecoll') .collection_product_page`).hide();
                    $(`#${closest_id} .auto-load-collection-desktop:not('.donecoll') .kclot_logo_icon`).remove();
                    
                  }
                  if(nextUrl == undefined){
                    $('.collection_product_page.collection-desktop:not(".doneload")').first().addClass('doneload');
                    $('.auto-load-collection-desktop:not(".donecoll")').first().addClass('donecoll')
                    nextUrl = '';
                  }
                  console.log(nextUrl,currentUrl);
                  triggered_desk = false;
                  if($('body.product-grid-with-cart').length > 0 || $('body.template-index').length > 0 ){
                    console.log("functions calleddd");
                    theme.grid_cart_btn();
                    theme.grid_add_to_cart_click();
                    theme.grid_popup_close();
                    theme.grid_popup_on_change();
                    if($(window).innerWidth() < 767 ){
                      theme.body_click_close();
                    }
                  }
                }
              });
        }
      }
    }
}
 $(window).scroll(function(){
    setTimeout(() => {
    if(product_count_custom != "0"){
      ScrollExecute();
    }
    }, 200);
 });
 
 /*====================== Mobile SubMenu Header ======================*/ 
  //   var default_nav = $('.nav-menu-top-main li.active').attr('data-handle');
  //   $('.collection-list-main ul.collection-list-sub li[data-handle="'+default_nav+'"]').show();
  //   $(document).on('click','.nav-menu-top-main li', function(e){
  //   // e.preventDefault();
  //    $('.nav-menu-top-main li').removeClass('active');
  //    $(this).addClass('active')
  //   var nav_handle = $(this).attr('data-handle');
  //    $('.collection-list-main ul.collection-list-sub li').hide();
  //    $('.collection-list-main ul.collection-list-sub li[data-handle="'+nav_handle+'"]').show();
  // });

  /*====================== Mobile Menu Currency Open ======================*/ 
  $(document).on('click', '.disclosure' , function(){
    if($('.mobilemenu-container').hasClass('scroll-disable')){
        $('.mobilemenu-container').removeClass('scroll-disable');
    }else{
         $('.mobilemenu-container').addClass('scroll-disable');
    }
  });
  $('.mobile-menu-close').on('click',function(){
    if($('.mobilemenu-container').hasClass('scroll-disable')){
        $('.mobilemenu-container').removeClass('scroll-disable');
    }
  });
  $('body').on('click',function(){
     if($('.mobilemenu-container').hasClass('scroll-disable')){
        $('.mobilemenu-container').removeClass('scroll-disable');
    }
  });
  
  // collection tab stickey
  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 220) {
        $(".static-filter").addClass("static-filter-active");
    }else if(scroll <= 150) {
         $(".static-filter").removeClass("static-filter-active");
    }
  }); 
  // collection tab stickey
   /*====================== Mega menu images slider Start======================*/ 
     $('.megamenu-images-slider').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false
    });
$('.site-navigation .site-nav__item').hover(function(){
 $('.megamenu-images-slider').slick('refresh');
});
   /*====================== Mega menu images slider End======================*/ 
  
    /*====================== Pdp Page Add to cart Start ======================*/ 
    if($(window).innerWidth() > 767 ){
      $('.addto_cart_variant_popup').hide();
        if ($('[option-target="option2"] .swatch-view.swatch-view-button .swatch-view-item[aria-checked="true"]').length > 0){
          $('.swatch-view.swatch-view-button .swatch-view-item[aria-checked="true"]').next().addClass('swatch-selected');
        }
    }
 
  if($(window).innerWidth() < 767 ){
    var variant_image , option1_val , option2_val ;
    // $('.product_form_wrap').hide();
    // Product color Option click
    $(document).on('click', '.product_form_wrap .swatch-view .swatch-view-item', function(){
      var $this = $(this), parent = $this.closest('.swatch-single');
      var optionName = parent.parent().attr('option-name');
      var optionNameLower = optionName.toLowerCase();
      var variantTitle = $this.attr('orig-value');
      if(optionNameLower == 'color'){
        $('.addto_cart_variant_popup .color-variant').text(variantTitle);
      }else{
        $('.addto_cart_variant_popup .size-variant').text(variantTitle);
      }
      parent.find('.validate-mesaage').remove();
      var product_price = 0;
      if($('.price-wrap .sale-price').length > 0 ){
        product_price = $('.product-price-title-wrap').find('.product__price.sale-price').text();
      }else{
        product_price = $('.product-price-title-wrap').find('.price-wrap > .product__price').text();
      }
      $('.addto_cart_variant_popup').find('.right_part').find('.price').text(product_price);
      $('.add-sticky-click').find('.right_part').find('.price').text(product_price);
      variant_image = $('.slick-active .product-image-main').find('.photoswipe__image').attr('data-photoswipe-src');
      $('.addto_cart_variant_popup .left_part img').attr('src' , variant_image );
    });
    
    $(document).on('click','.add-sticky-click',function(e){
        e.preventDefault();
        var $this = $(this);
        theme.featured_image_add_to_cart($this);
    });
   //Product add to cart popup close button click
    $('.addto_cart_close').on('click',function(){
      $('.product_form_wrap').hide();
      // $('body').removeClass('cart_popup_overlay');
      // $('form.product-single__form').removeClass('form_popup_add');
      $('.bottom-sticky-product').removeClass('add_to_cart_btn_popup');
      // $('#validate-message1').remove();
      // $('#validate-message2').remove();
      // $('#validate-message3').remove();
    });
    //Product popup close on body click
    $('body').on('touchstart  click',function(e){
      if($(e.target).closest('.product-single__form').length == 0 && $(e.target).closest('.bottom-sticky-product').length == 0 && $(e.target).closest('.kiwi-sizing-modal').length == 0 && $(e.target).closest('.ks-chart-modal-link').length == 0){
        // $('body').removeClass('cart_popup_overlay');
        // $('form.product-single__form').removeClass('form_popup_add');
        $('.bottom-sticky-product').removeClass('add_to_cart_btn_popup');
        setTimeout(function(){$('.product_form_wrap').hide();}, 200);
        // $('validate-message1').remove();
        // $('#validate-message2').remove();
        // $('#validate-message3').remove();
      }
    });
    // $('.form_popup_add::after').on('click',function(){
    //      $('.product_form_wrap').hide();
    //     $('.pdp-background-overlay').removeClass('cart_popup_overlay');
    //     $('form.product-single__form').removeClass('form_popup_add');
    //     $('.swatch-view.swatch-view-button , .swatch-view.swatch-view-image').find('.swatch-view-item').removeAttr('aria-checked'); 
    //     $('.swatch-view.swatch-view-button li').find('.swatch-button').removeClass('swatch-selected'); 
    //     // $('.swatch-view.swatch-view-image').find('.swatch-view-item').removeAttr('aria-checked');
    //     $('.swatch-view.swatch-view-image li').find('.swatch-image').removeClass('swatch-selected');
    //     $('.bottom-sticky-product').removeClass('add_to_cart_btn_popup');
    //     $('#validate-message1').remove();
    //     $('#validate-message2').remove();
    //     $('#validate-message3').remove();
    // });
  } 
  /*====================== Pdp Page Add to cart End ======================*/  
  /*====================== Pdp Page Variant Images Start ======================*/ 

  theme.variant_image_slider = function(){
    $('.variant-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 3,
      arrows:true
    });
  }
  $('.color-variant-image').on('click',function(){
    $('.color-variant-image').removeClass('active');
    var media_id = $(this).attr('data-media-id');
    var media_index = $('.slide_goto[data-mediaid="'+ media_id +'"]').attr('data-index');
    var section_id = $(this).closest('.product-section').attr('data-section-id');
    $(this).addClass('active');
    $('#ProductPhotos-'+ section_id).slick('slickGoTo', media_index);
  });
  if($('.color-variant-image').length > 4 ){
    $('.variant-image-mobile-container').addClass('variant-slider');
  }
  var variant_image_slider = setInterval(function() {
    if ($(".variant-image-mobile-container.variant-slider").length > 0) {
      theme.variant_image_slider();
      // console.log($('.variant-image-mobile-container.variant-slider').length);
      clearInterval(variant_image_slider);
    }
  }, 100);

  /*====================== Pdp Page Variant Images End ======================*/ 

     /*====================== Pdp Page Shipping Badge popup Start ======================*/ 

     if($(window).innerWidth() < 767 ){
      $('.product-discount-badge').on('click',function(){
        // console.log("Clicked badge");
        $('.main-shipping-popup-container').show();
      });
  
      $('.freeship_popup_close').on('click',function(){
        $('.main-shipping-popup-container').hide();
      });
      // Click on content to copy on clipboard
      $('.content-code').on('click',function(){
        var code_text = $(this).find('p').text();
        // console.log('code_text',code_text);
        navigator.clipboard.writeText(code_text);
      });
      $('body').on('touchstart  click',function(e){
        if($(e.target).closest('.shipping-popup-main').length == 0 && $(e.target).closest('.product-discount-badge').length == 0){
          $('.main-shipping-popup-container').hide();
        }
      });
     }
  
    /*====================== Pdp Page Shipping Badge popup End ======================*/ 
    
    /*  Collection page quickview Tab functionality Start */
      var checkExist = setInterval(function() {
      $('.boost-pfs-filter-products .grid__item').each(function(){
          if($(this).find('.modal').hasClass('modal--is-active')) {
               modeltabclicked();
              model_load_more_clicked();
              console.log('temp coll',$('.template-collection').length);
              if($('.template-collection').length > 0){
                payment_popup();}
               clearInterval(checkExist);
          }
      });
    }, 500);
     function modeltabclicked(){  
      $('.product-detail-tab-container .tabs li').bind('click',function(){
      		var tab_id = $(this).attr('data-tab');
          // console.log('tab_id',tab_id);
      	$('ul.tabs li').removeClass('current');
  		$('.tab-content').removeClass('current');
      
      		$(this).addClass('current');
      		$("[data-tab="+tab_id+"]").addClass('current');
      });   
    }
    function model_load_more_clicked(){
      $('.product-detail-tab-container .moreless-button').on('click',function() {
        $('.product-description').slideToggle();
        if ($(this).text() == "Load more") {
          $(this).text("Load less")
           $('.product-truncatewords-description').hide();
        } else {
          $(this).text("Load more")
           $('.product-truncatewords-description').show();
        }
      });
    }
    function payment_popup(){

      // When the user clicks on the button, open the modal
      		$('.mypaymentBtn').on('click',function(){
        	$('.modal1').css('display','block');
            // $('body').addClass('payment-popup');
      		});
      // When the user clicks on <span> (x), close the modal
        
           $('.close1').on('click',function(){
        		$('.modal1').css('display','none');
                // $('body').removeClass('payment-popup');
        	});
              // When the user clicks anywhere outside of the modal, close it
            $('.modal__centered').on('click',function(e){
              // console.log('ee',e.target);
               if($(e.target).closest('.modal-content-container').length == 0  && $(e.target).closest('.afterpay-info').length == 0){
                 $('.modal1').css('display','none');
                 $('body').removeClass('payment-popup');
               }
            });
         }
    /*  Collection page quickview Tab functionality End */

    /*  Homepage flash sale js start */
     $('.product-flash-slider').slick({
        infinite: false,
        arrows: true,
        nextArrow: "<img class='next slick-next' src='https://cdn.shopify.com/s/files/1/0535/9527/5424/files/20230510113344.png?v=1683697120'>",
        prevArrow:"<img class='prev slick-prev' src='https://cdn.shopify.com/s/files/1/0535/9527/5424/files/20230510113338.png?v=1683697120'>",
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 3,
              infinite: false,
              arrows: true
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
              infinite: false,
              arrows: true
            }
          },
           {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: false,
              arrows: false,
              dots:false
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: false,
              arrows: true,
              dots:false
            }
          }
      ]
    });

  $('.product-page-grid-slider').slick({
      infinite: false,
      arrows: true,
      nextArrow: "<img class='next slick-next' src='https://cdn.shopify.com/s/files/1/0535/9527/5424/files/20230510113344.png?v=1683697120'>",
      prevArrow:"<img class='prev slick-prev' src='https://cdn.shopify.com/s/files/1/0535/9527/5424/files/20230510113338.png?v=1683697120'>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 3,
            infinite: false,
            arrows: true
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            infinite: false,
            arrows: true
          }
        },
         {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            arrows: false,
            dots:false
          }
        },
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            arrows: true,
            dots:false
          }
        }
    ]
  });
    /* Mobile collection list slider start */
    if($(window).innerWidth() < 767 ){
      $('.collection-list-slider-mobile').slick({
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: true,
        arrows: false,
        dots: false,
        mobileFirst: true,
        variableWidth: true
      });
    }
  /* Mobile collection list slider End */
});
if($(window).innerWidth() < 767 ){
  $( window ).on( "load", function() {
    // $('.bottom-sticky-product .add-sticky-click').removeClass('disable');
    // // $('.product_form_wrap').hide();
    // $('.swatch-view.swatch-view-image').find('.swatch-view-item').removeAttr('aria-checked');
    // $('.add-sticky-click').removeClass('unload');
  });

}
// window.addEventListener('load', function (){
//   console.log('Function #1');
//   alert("helloo");
// });

/* ---START--- drawer_item_popup */
theme.drawer_item_popup = function(){
  $(document).on('click', '.addto_cart_variant_popup', function(){
    $('.cart_drawer_item_popup').hide();
  });

  $(document).on('click', '.ajaxcart__product-meta', function(){
    var drawerQty = $(this).parents('.grid__item.two-thirds').find('.js-qty__num').val();
    var productHandle = $(this).attr('product-handle');
    var variantIdCur = $(this).attr('variant-id');
    
    var url = '/products/'+ productHandle +'?variant='+ variantIdCur +'=&view=cartdrawer';
    $.ajax({
      url: url,
      success: function(data) {
        $('.cart_drawer_item_popup').html(data);
        $('.cart_drawer_item_popup .current_variant_detail').attr('variant-qty', drawerQty);
        $('.cart_drawer_item_popup .current_variant_detail').attr('variant-id-drawer', variantIdCur);

        $('.cart_drawer_item_popup .variant-input-wrap-popup[data-option-index="0"] input:checked').trigger('change');

        $('.cart_drawer_item_popup .swatch-view-item-popup').each(function(){
          var variantTitle = $(this) .attr('orig-value');
          var variantSoldputLen = $(`.cart_drawer_item_popup .product-single__variants option[variant-title^="${variantTitle}"][data-sold="soldout"]`).length;
          var variantOption = $('.cart_drawer_item_popup .variant-input-wrap .variant-input').length;
          if(variantSoldputLen == variantOption){
            $(this).addClass('swatch-item-unavailable');
          }
        });

        var selectImg = $('.cart_drawer_item_popup .addto_cart_variant_popup .left_part img').attr('src');
        $('.material_img').attr('src',selectImg);

        $('.cart_drawer_item_popup').css('display','flex');
      }
    });
  });

  $(document).on('click', '.swatch-view-item-popup', function(){
    variantImg = $(this).find('.star-set-image').attr('option-data-img');
    $('.cart_drawer_item_popup .left_part img').attr('src', variantImg);
  });

  $(document).on('change', '.cart_drawer_item_popup .variant__input-template_product_popup_section', function() {
    var $this = $(this);
    var optionText = '';
    $('.cart_drawer_item_popup .variant-input-wrap-popup').each(function(){
      optionData = $(this).find('.variant__input-template_product_popup_section:checked').val();
      optionText = optionText +' / ' + optionData;
    });
    optionDataNew = optionText.slice(3);

    var optionVariantId = $(`.cart_drawer_item_popup .select_dropdown_option[variant-title="${optionDataNew}"]`).val();
    var variantPrice = $(`.cart_drawer_item_popup .select_dropdown_option[variant-title="${optionDataNew}"]`).attr('variant-price');
    var varaintColor = $('.cart_drawer_item_popup .variant__input-template_product_popup_section[name="Color"]:checked').val();
    var optionSize = $('.cart_drawer_item_popup .variant__input-template_product_popup_section[name="Size"]:checked').val();
    var optionTitle = $('.cart_drawer_item_popup .variant__input-template_product_popup_section[name="Title"]:checked').val();
    // var variantImg = $(`.cart_drawer_item_popup .select_dropdown_option[variant-title="${optionDataNew}"]`).attr('variant-img');

    // $('.cart_drawer_item_popup .left_part img').attr('src', variantImg);
    $('.cart_drawer_item_popup .right_part .price').text(variantPrice);
    $('.cart_drawer_item_popup .product-single__form .add-product_btn.add_to_cart_btn_popup .add-cart.btn .price').text(variantPrice);
    $('.cart_drawer_item_popup .add-product_btn .add-sticky-click .right_part .price').text(variantPrice);
    $('.cart_drawer_item_popup .right_part .variant_selected_rank_wrap .color-variant').text(varaintColor);
    $('.cart_drawer_item_popup .right_part .variant_selected_rank_wrap .size-variant').text(optionSize);
    $('.cart_drawer_item_popup .right_part .variant_selected_rank_wrap .title-variant').text(optionTitle);
    $('.cart_drawer_item_popup .current_variant_detail').attr('variant-id', optionVariantId);

    var selectImg = $('.cart_drawer_item_popup .addto_cart_variant_popup .left_part img').attr('src');
    $('.material_img').attr('src',selectImg);
    var currentSelectedVarTitle = '';
    if($('.cart_drawer_item_popup .variant-input-wrap-popup[data-option-index="0"] input:checked').length > 0){
      currentSelectedVarTitle = $('.cart_drawer_item_popup .variant-input-wrap-popup[data-option-index="0"] input:checked').attr('data-value');
    }
    if($('.cart_drawer_item_popup .variant-input-wrap-popup[data-option-index="1"] input:checked').length > 0){
      currentSelectedVarTitle = currentSelectedVarTitle + ' / ' + $('.cart_drawer_item_popup .variant-input-wrap-popup[data-option-index="1"] input:checked').attr('data-value');
    }
    if($('.cart_drawer_item_popup .variant-input-wrap-popup[data-option-index="2"] input:checked').length > 0){
      currentSelectedVarTitle = currentSelectedVarTitle + ' / ' + $('.cart_drawer_item_popup .variant-input-wrap-popup[data-option-index="2"] input:checked').attr('data-value');
    }
    if($(`.cart_drawer_item_popup #ProductSelect-template_product_popup_section option[variant-title="${currentSelectedVarTitle}"]`).attr('data-sold') == 'soldout'){
      $('.cart_drawer_item_popup .add-product_btn.add_to_cart_btn_popup').addClass('disabled');
      $('.cart_drawer_item_popup .add-product_btn.add_to_cart_btn_popup .add-cart.btn .add_to_bag').text('Soldout');
    }else{
      $('.cart_drawer_item_popup .add-product_btn.add_to_cart_btn_popup .add-cart.btn .add_to_bag').text('Add to bag');
      $('.cart_drawer_item_popup .add-product_btn.add_to_cart_btn_popup').removeClass('disabled');
    }
    theme.swatchUnavailable($this);
  });

  /* Add to cart product */
  $(document).on('click','.cart_drawer_item_popup .add-product_btn', function(e){
    e.preventDefault();
    var $this = $(this);
    let itemId = parseInt($('.cart_drawer_item_popup .current_variant_detail').attr('variant-id-drawer'));     
    let dataForm = `&updates[${itemId}]=0`;
    var currentVariantId = $('.cart_drawer_item_popup .current_variant_detail').attr('variant-id');
    var currentVariantQty = $('.cart_drawer_item_popup .current_variant_detail').attr('variant-qty');
    if(currentVariantId == '' || currentVariantQty == ''){
      $('.cart_drawer_item_popup').hide();
      return false;
    }
    $this.addClass('btn--loading');
    $this.addClass('unload');
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: dataForm,
      dataType: "json",
      success: function (response) {
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: parseInt(currentVariantId),
            quantity: parseInt(currentVariantQty)
          },
          dataType: "json",
          success: function (result) {
            $this.removeClass('btn--loading');
            $this.removeClass('unload');
            $('body').trigger('added.ajaxProduct', $this.$addToCart);
            $('.cart_drawer_item_popup .product-single__form').remove();
            $('.cart_drawer_item_popup').hide();
          },
          error: function () {
            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: {
                id: parseInt(itemId),
                quantity: parseInt(currentVariantQty)
              },
              dataType: "json",
              success: function (result) {
                $this.removeClass('btn--loading');
                $this.removeClass('unload');
                $('body').trigger('added.ajaxProduct', $this.$addToCart);
                $('.cart_drawer_item_popup .product-single__form').remove();
                $('.cart_drawer_item_popup').hide();
              }
            });
          }
        });
      }
    });
  });
  /* -- END -- Add to cart product */
}

theme.swatchUnavailable = function($this){
  var currVariantTitle = '';
  var optionIndex = parseInt($this.parents('.variant-input-wrap-popup').attr('data-option-index'));
  if(optionIndex == 0){
    currVariantTitle = $this.closest('.variant_common_option').attr('data-value');
    $this.parents('.product-single__form').find(`.variant-input-wrap-popup[data-option-index="1"] .variant-input`).removeClass('swatch-item-unavailable');
    $this.parents('.product-single__form').find(`.variant-input-wrap-popup[data-option-index="2"] .variant-input`).removeClass('swatch-item-unavailable');
  }else if(optionIndex == 1){
    currVariantTitle = $this.closest('.product_option_main').find('.variant-input-wrap-popup[data-option-index="0"] input:checked').attr('value')+' / '+$this.closest('.variant_common_option').attr('data-value');
    $this.parents('.product-single__form').find(`.variant-input-wrap-popup[data-option-index="2"] .variant-input`).removeClass('swatch-item-unavailable');
  }else if(optionIndex == 2){
    currVariantTitle = $this.closest('.product_option_main').find('.variant-input-wrap-popup[data-option-index="0"] input:checked').attr('value')+' / '+$this.closest('.product_option_main').find('.variant-input-wrap-popup[data-option-index="1"] input:checked').attr('value')+' / '+$this.closest('.variant_common_option').attr('data-value');
  }
  var productId = $this.parents('.product-single__form').find(`.product-single__variants`).attr('data-productid');
  $this.parents('.product-single__form').find(`.product-single__variants option[variant-title^="${currVariantTitle}"][data-sold="soldout"]`).each(function(){
    var variantTitle = $(this).attr('variant-title');
    var res = variantTitle.split(" / ");
    var shoesOption = $this.parents('.product-single__form').find(`.product-single__variants .variant_option_shoes_size`).length;

    if(shoesOption > 0){
      $this.parents('.product-single__form').find(`.variant_input_option[value="${res[1]} / ${res[2]}"]`).parent('.variant-input').addClass('swatch-item-unavailable');
    }else{
      if(optionIndex == 0){
        $this.parents('.product-single__form').find(`.variant_input_option[value="${res[1]}"]`).parent('.variant-input').addClass('swatch-item-unavailable');
        $this.parents('.product-single__form').find(`.variant_input_option:checked`).trigger('change');
      }else if(optionIndex == 1){
        $this.parents('.product-single__form').find(`.variant_input_option[value="${res[2]}"]`).parent('.variant-input').addClass('swatch-item-unavailable');
      }
    }
  });
}

theme.drawer_item_popup();

var popularItemNostoDrawer = setInterval(function() {
  var popularItemLength = $('#CartDrawer .nosto-grid .popular-items .nosto_element .nosto-block .nosto-list-item').length;
  if(popularItemLength > 0){
    $('#CartDrawer .nosto-grid .popular-items').show();
    clearInterval(popularItemNostoDrawer);
  }
},100);

var YouMayAlsoNostoDrawer = setInterval(function() {
  var alsoLikeItemLength = $('#CartDrawer .nosto-grid .you-may-like .nosto_element .nosto-block .nosto-list-item').length;
  if(alsoLikeItemLength > 0){
    $('#CartDrawer .nosto-grid .you-may-like').show();
    clearInterval(YouMayAlsoNostoDrawer);
  }
},100);

/* ---END--- drawer_item_popup */

theme.tab_product_load_more = function(tab_triggered){
  $(window).scroll(function(){
   var active_heading = $('.tab-content-main-wrapper .tab-heading-main .tab-content.active').closest('.tab-head').data('index');
   var active_content = $(`.tab-content-main-wrapper .tabmenu-content .inner-content[data-index="${active_heading}"]`);
   var load_more_btn = $(`.tab-content-main-wrapper .tabmenu-content .inner-content[data-index="${active_heading}"] .collection_product_page`)
     if(load_more_btn.isInViewport() && (tab_triggered == false)){
        var nextUrl = $(active_content).find('.collection-products-load-more-link').attr("href");
        $(active_content).find('.kclot_logo_icon').removeClass('hide');
        tab_triggered = true;
         $.ajax({
            url: nextUrl,
            type: 'GET',
            success: function (response) {
                nextUrl = $(response).find(`.tab-content-main-wrapper .tabmenu-content .inner-content[data-index="${active_heading}"] .collection-products-load-more-link`).attr("href");
                currentUrl = $(active_content).find('.collection-products-load-more-link').attr("href");       $(active_content).find('.kclot_logo_icon').addClass('hide');
                $(active_content).find('.product-grid').append(
                  $(response).find(`.tab-content-main-wrapper .tabmenu-content .inner-content[data-index="${active_heading}"] .product-grid`).html()
                );
                if( $(response).find(`.tab-content-main-wrapper .tabmenu-content .inner-content[data-index="${active_heading}"] .collection-products-load-more-main a`).length > 0){
                  $(active_content).find('.collection-products-load-more-main a').attr("href",$(response).find(`.tab-content-main-wrapper .tabmenu-content .inner-content[data-index="${active_heading}"] .collection-products-load-more-main a`).attr("href"));
                $(active_content).find('.collection-products-load-more-main').show();
                }else{
                  $(active_content).find('.collection_product_page').hide();
                  $(active_content).find('.kclot_logo_icon').remove();
                }
                tab_triggered = false;
                if($('body.product-grid-with-cart').length > 0 || $('body.template-index').length > 0 ){
                  console.log("functions calleddd");
                  theme.grid_cart_btn();
                  theme.grid_add_to_cart_click();
                  theme.grid_popup_close();
                  theme.grid_popup_on_change();
                  if($(window).innerWidth() < 767 ){
                    theme.body_click_close();
                  }
                }
              }
          });
      }
  });
}
